var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('div',{staticClass:"header__logo"},[_c('a',{attrs:{"href":"#","target":"_blank"}},[_c('img',{attrs:{"src":require("./../../assets/images/hrdesk-logo-dark-beta.png"),"alt":"logo"}})])]),_c('div',{staticClass:"header__nav"})])
}]

export { render, staticRenderFns }